import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

export default function ConfidentialPolicy() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>Політика конфіденційності LeelaOnline.net</h1>
            <h3>1. Вступ</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми піклуємось про збереження, цілісність та конфіденційність ваших даних.</li>
                    <li className={StaticPageStyles.staticPageText}>Ми вживаємо всіх доступних нам технічних та організаційних заходів для забезпечення збереження, цілісності та конфіденційності ваших даних.</li>
                    <li className={StaticPageStyles.staticPageText}>Використовуючи цей сайт, ви погоджуєтеся з цією політикою конфіденційності.</li>
                    <li className={StaticPageStyles.staticPageText}>Будь ласка, уважно ознайомтеся з цією політикою перед початком використання нашого сайту.</li>
                </ul>
            </p>

            <h3>2. Типи даних що зберігаються</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Особиста інформація:</b> Ім'я, електронна адреса тощо.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Технічна інформація:</b> IP-адреса, тип браузера, операційна система, дані про відвідування сторінок тощо.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Інформація про використання:</b> Дані про ваші дії на сайті, такі як переглянуті сторінки, час, проведений на сайті, ігрові результати тощо.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Інші дані:</b> Будь-які інші дані, які ви надаєте під час використання нашого сайту або послуг.</li>
                </ul>
            </p>

            <h3>3. Зберігання даних</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми зберігаємо ваші дані тільки стільки, скільки це необхідно для досягнення цілей, для яких вони були зібрані, або для дотримання юридичних вимог.</li>
                    <li className={StaticPageStyles.staticPageText}>Ваші дані зберігаються на захищених серверах що використовують передові технології захисту</li>

                </ul>
            </p>



            <h3>4. Передача даних третім особам</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми не передаємо без вашої згоди третім сторонам жодних ваших даних, крім випадків: </li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>явно зазначених при введенні даних </li>
                        <li className={StaticPageStyles.staticPageText}>явно перелічених у цій політиці </li>
                        <li className={StaticPageStyles.staticPageText}>передбачених чинним законодавством </li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>Ваші дані можуть бути передані стороннім надавачам послуг для забезпечення роботи сайту та його послуг (наприклад проведення платежів)</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Ми ретельно вивчаємо всіх надавачів послуг що б пересвідчитись що їх політика конфіденційності відповідає нашій.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>Дані що передаються третім особам</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}><b>Псевдонім:</b>Ваш псевдонім є вашим публічним представленням, і використовується для вашого представлення іншим провідникам, гравцям та відвідувачам сайту.</li>
                        <li className={StaticPageStyles.staticPageText}><b>Назви та описи ігрових карток:</b>видимі гравцям ваших ігор через унікальне посилання на гру</li>
                        <li className={StaticPageStyles.staticPageText}><b>Завантажене зображення ігрового поля:</b>видимі гравцям ваших ігор через унікальне посилання на гру</li>
                        <li className={StaticPageStyles.staticPageText}><b>Завантажені музичні файли у якості музичного супроводу гри: </b>за вашим запитом будуть відтворені на стороні гравця гри </li>
                        <li className={StaticPageStyles.staticPageText}><b>Дані введені у формі “Запит гравця” ігрового поля:</b>будуть видимі гравцю цієї гри через унікальне посилання на гру</li>
                        <li className={StaticPageStyles.staticPageText}><b>Назва гри та ім'я гравця введені при створені гри:</b>будуть видимі гравцю цієї гри через унікальне посилання на гру</li>
                        <li className={StaticPageStyles.staticPageText}>**Гравець гри - будь яка особа котрій передано унікальне посилання на гру</li>

                    </ul>

                </ul>
            </p>

            <h3>5. Використання даних</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми не використовуємо ваших даних для будь яких цілей крім забезпечення процесу гри, покращення та розвитку нашого продукту</li>
                    <li className={StaticPageStyles.staticPageText}>Вашу адресу електронної пошти може бути використано для звʼязку з вами у разі необхідності та неможливості звʼязатись у інший спосіб</li>
                    <li className={StaticPageStyles.staticPageText}>Вашу адресу електронної пошти може бути використано для повідомлення вам про важливі чи критичні зміни в функціональності продукту</li>
                </ul>
            </p>

            <h3>6. Обмежений доступ до даних</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Доступ працівників LeelaOnline до ваших даних надано тільки обмеженому колу технічних фахівців кому це необхідно для виконання роботи з розвитку та покращення продукту чи аналізу технічних несправностей</li>
                    <li className={StaticPageStyles.staticPageText}>Працівникам LeelaOnline що мають доступ до ваших даних заборонено використовувати їх для будь яких цілей окрім виконання роботи з розвитку та покращення продукту чи аналізу технічних несправностей</li>
                    <li className={StaticPageStyles.staticPageText}>Працівникам LeelaOnline що мають доступ до ваших даних заборонено поширювати їх у будь якій формі за межами кола осіб що мають доступ до них.</li>
                </ul>
            </p>

            <h3>7. Шляхи захисту ваших даних:</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Ім'я користувача та пароль: </b>Дані що не передаються третім особам доступні користувачу тільки після введення коректного імені користувача та паролю.</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Не передавайте ваш пароль нікому.</li>
                        <li className={StaticPageStyles.staticPageText}>Використовуйте достатньо складний та довгий пароль.</li>
                        <li className={StaticPageStyles.staticPageText}>Жоден представник LeelaOnline ніколи не проситиме вас надати ваш пароль.</li>
                        <li className={StaticPageStyles.staticPageText}>Ми не несемо відповідальності за збереження, цілісність та конфіденційність ваших даних у випадку передачі вами паролю третім особам у явній чи неявній формі.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}><b>Унікальне посилання: </b>Кожна гра, та дані доступні в ній захищені унікальним кодом в посиланні. </li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Посилання має надзвичайно високий рівень захисту, його майже неможливо вгадати чи підібрати.</li>
                        <li className={StaticPageStyles.staticPageText}>Передаючи посилання третім особам ви фактично надаєте доступ до даних доступних у ігровому процесі,  вже введених чи тих що будуть введені у майбутньому</li>

                    </ul>
                </ul>
            </p>

            <h3>8. Ваші права</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ви маєте право:</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Отримувати інформацію про обробку ваших персональних даних.</li>
                        <li className={StaticPageStyles.staticPageText}>Вимагати виправлення або видалення ваших персональних даних.</li>
                        <li className={StaticPageStyles.staticPageText}>Обмежувати обробку ваших даних.</li>
                        <li className={StaticPageStyles.staticPageText}>Відкликати згоду на обробку даних.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>У випадку вимоги на видалення, обмеження чи відкликання дозволу на обробку персональних даних
                        ваш обліковий запис може бути видалено без можливості відновлення, а доступ до певних частин сайту обмежений.</li>
                </ul>
            </p>

            <h3>9. Файли cookies</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми використовуємо файли cookies для покращення вашого досвіду на нашому сайті.
                        Файли cookies допомагають нам аналізувати трафік, запам'ятовувати ваші вподобання та налаштування.</li>
                </ul>
            </p>



            <h3>10. Зміни до цієї політики</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми залишаємо за собою право внесення змін до цієї політики без попереднього узгодження. Про зміни буде повідомлено електронним листом на електронну адресу користувачів.</li>
                </ul>
            </p>

            <h3>11. Контактна інформація</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Якщо у вас є питання або зауваження щодо цієї політики конфіденційності, будь ласка, зв'яжіться з нами через електронну адресу.
                    </li>
                    <a href={"mailto:support@leelaonline.net"}>support@leelaonline.net</a>
                </ul>
            </p>

        </div>
    )
}